// src/pages/FormNew.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TabsWrapper from '../components/TabsWrapper';
import { 
  Paper, Typography, Box, Divider, CircularProgress, 
  Card, CardContent, Stack, Grid, alpha, useTheme 
} from '@mui/material'; // Імпорти MUI
import { 
  DescriptionOutlined, CalendarToday, Schedule, AssignmentInd 
} from '@mui/icons-material'; // Нові іконки

// ✅ Імпорт сервісу зберігання
import { getData } from '../services/storageService';
// ✅ Імпорт i18n
import { useI18n } from '../i18n/i18n';

export default function FormNew({ user }) {
  const { t } = useI18n(); // ✅
  const theme = useTheme(); // ✅
  const [activeShift, setActiveShift] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadShiftData = async () => {
      try {
        const shiftData = await getData('current_shift');
        if (shiftData) {
          setActiveShift(shiftData);
        } else {
          // ✅ i18n
          alert(t('form.no_active_shift_alert', 'No hay un turno activo. Redirigiendo...'));
          navigate('/open-shift');
        }
      } catch (error) {
        console.error("Error loading active shift data:", error);
        // ✅ i18n
        alert(t('form.load_error_alert', 'Error al cargar los datos del turno.'));
        navigate('/dashboard');
      } finally {
        setLoading(false);
      }
    };

    loadShiftData();
  }, [navigate, t]); // ✅ Додано t

  if (loading || !activeShift) {
    return (
        // ✅ Оновлений стиль завантаження
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '60vh',
          flexDirection: 'column',
          gap: 3 
        }}>
            <CircularProgress size={60} />
            <Typography variant="h6" color="text.secondary">
                {t('form.loading', 'Cargando datos del turno...')}
            </Typography>
        </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1200, margin: '0 auto', p: 3 }}>
      
      {/* ✅ Новий заголовок (стиль з AnalyticsPage) */}
      <Box sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 60,
              height: 60,
              borderRadius: '16px',
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.3)}`
            }}
          >
            <DescriptionOutlined sx={{ color: 'white', fontSize: 32 }} />
          </Box>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
              {t('form.title', 'Parte de Producción')}
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400 }}>
              {t('form.subtitle', 'Registro de datos del turno activo')}
            </Typography>
          </Box>
        </Stack>
      </Box>

      {/* ✅ Оновлена Картка Статусу Зміни (стиль з ShiftStatusCard) */}
      <Card sx={{ 
        mb: 3,
        background: `linear-gradient(135deg, ${alpha(theme.palette.success.light, 0.1)} 0%, ${alpha(theme.palette.success.main, 0.05)} 100%)`,
        border: `2px solid ${alpha(theme.palette.success.main, 0.2)}`,
        borderRadius: 3
      }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: theme.palette.success.dark }}>
            {t('form.shift_info_title', 'Información del Turno Activo')}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <CalendarToday sx={{ color: 'text.secondary', fontSize: '1.2rem' }} />
                <Typography>
                  <strong>{t('labels_date', 'Fecha')}:</strong> {activeShift.fecha}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Schedule sx={{ color: 'text.secondary', fontSize: '1.2rem' }} />
                <Typography>
                  <strong>{t('labels_shift', 'Turno')}:</strong> {activeShift.turno}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <AssignmentInd sx={{ color: 'text.secondary', fontSize: '1.2rem' }} />
                <Typography>
                  <strong>{t('labels_operators', 'Operadores')}:</strong> {activeShift.operators.join(', ')}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Передаємо завантажені дані до TabsWrapper */}
      <TabsWrapper user={user} shiftData={activeShift} />
    </Box>
  );
}


